import React from 'react';
import { cn } from '@/lib/utils';
import { normalizeLeadStatus } from '@/lib/leadStatus';

// Konsolidiertes Lead-Statusmodell — Legacy-Werte werden via
// normalizeLeadStatus auf die 6 kanonischen Statuswerte abgebildet.
const statusColors = {
  'Potenzieller Interessent': 'border-purple-500 bg-purple-50 text-purple-700',
  'Interessenten': 'border-amber-500 bg-amber-50 text-amber-700',
  'Kunde': 'border-emerald-500 bg-emerald-50 text-emerald-700',
  'Verlorene Kunden': 'border-red-500 bg-red-50 text-red-700',
  'eBay': 'border-yellow-500 bg-yellow-50 text-yellow-700',
  'Shopify': 'border-green-500 bg-green-50 text-green-700',
};

const taskStatusColors = {
  'Offen': 'bg-blue-100 text-blue-700',
  'Abgeschlossen': 'bg-green-100 text-green-700',
  'Überfällig': 'bg-red-100 text-red-700',
};

const orderTypeColors = {
  'Angebot': 'bg-orange-100 text-orange-700 border-orange-300',
  'Bestellung': 'bg-emerald-100 text-emerald-700 border-emerald-300',
};

// Sipariş lifecycle statü renkleri — 7 aşamalı model + Storniert.
// type='orderStatus' ile çağrılır.
const orderStatusColors = {
  'Neu':            'bg-blue-50    text-blue-700    border-blue-200',
  'Kommissioniert': 'bg-purple-50  text-purple-700  border-purple-200',
  'Versandbereit':  'bg-indigo-50  text-indigo-700  border-indigo-200',
  'Unterwegs':      'bg-amber-50   text-amber-700   border-amber-200',
  'Geliefert':      'bg-teal-50    text-teal-700    border-teal-200',
  'Berechnet':      'bg-cyan-50    text-cyan-700    border-cyan-200',
  'Abgeschlossen':  'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Storniert':      'bg-red-50     text-red-700     border-red-200',
};

export default function StatusBadge({ status, type = 'lead', className }) {
  let colorClass = '';

  const displayStatus = type === 'lead' ? normalizeLeadStatus(status) : status;

  if (type === 'lead') {
    colorClass = statusColors[displayStatus] || 'border-slate-300 bg-slate-50 text-slate-600';
  } else if (type === 'task') {
    colorClass = taskStatusColors[status] || 'bg-slate-100 text-slate-600';
  } else if (type === 'order') {
    colorClass = orderTypeColors[status] || 'bg-slate-100 text-slate-600';
  } else if (type === 'orderStatus') {
    colorClass = orderStatusColors[status] || 'bg-slate-100 text-slate-600';
  }

  return (
    <span className={cn(
      'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border',
      type === 'lead' ? 'border-l-4' : 'border',
      colorClass,
      className
    )}>
      {displayStatus}
    </span>
  );
}

export { statusColors, taskStatusColors, orderTypeColors, orderStatusColors };
